// Centralized API base URL with environment override for dev/prod
// Use REACT_APP_API_BASE_URL to configure in deployment; defaults to local API.
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5283';

export const buildApiUrl = (path = '') => {
  if (!path) return API_BASE_URL;
  if (typeof path === 'string' && path.startsWith('http')) return path;
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  return `${API_BASE_URL}${normalizedPath}`;
};
